import { render, staticRenderFns } from "./DatabaseTemplate.vue?vue&type=template&id=09703c7c&scoped=true"
import script from "./DatabaseTemplate.vue?vue&type=script&lang=js"
export * from "./DatabaseTemplate.vue?vue&type=script&lang=js"
import style0 from "./DatabaseTemplate.vue?vue&type=style&index=0&id=09703c7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09703c7c",
  null
  
)

export default component.exports